import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { useStoreDispatch } from "../../../store/Hooks";
import { navSliceActions } from "../../../store/slices/NavSlice";
import CopyAllIcon from '@mui/icons-material/CopyAll';
import Communication from "../../../models/communications/Communication";

interface InteractionCopyButtonProps {
  type:string;
  pathwayNode?: any;
  interaction?:any;
  handleCopyCommSet?:any;
  setEditMode?:any
  communicationSetID?:any;
  communication?:Communication;
  handleCopyCommunication?:any;

}


const InteractionCopyButton = (props:InteractionCopyButtonProps ) => {

  const dispatch = useStoreDispatch();

  const handleClick = async (e:any) => {
    if(props.type == "pathway"){
      dispatch(
        navSliceActions.openModal({
          caresenseModalAlertType: "pathway_copy",
          caresenseModalAlertMessage: "This action will replace this shared entity with an anonymous copy of it. Proceed?",
          caresenseModalAlertEntityID: props.interaction?.id,
          modalCallback: async () => {
            e.stopPropagation();
            await props.pathwayNode?.copy();
            // after creating the copy, delete the original node
            await props.pathwayNode?.delete();
            // TODO - the copy function DOES return a map of the updated
            //        state for replacement, so at some point we could
            //        do a local state update instead of full refresh
            window.location.reload();

          } // post callback to redux so modal alert calls it on user approval
        }),
      );
      } else if (props.type=="communication set"){
        dispatch(
          navSliceActions.openModal({
            caresenseModalAlertType: "communications_set_copy",
            caresenseModalAlertMessage: "This action will replace this shared entity with an anonymous copy of it. Proceed?",
            caresenseModalAlertEntityID: props.communicationSetID,
            modalCallback: async () => {
              props.handleCopyCommSet();
              props.setEditMode(true);
              } // post callback to redux so modal alert calls it on user approval
          }),
        );
      }  else if (props.type=="communication" && props.communication){
        dispatch(
          navSliceActions.openModal({
            caresenseModalAlertType: "communications_copy",
            caresenseModalAlertMessage: "This action will create a new copy of this communication directly below it. Proceed?",
            caresenseModalAlertEntityID: props.communication.id,
            modalCallback: async () => {
              if(props.communication){
                const newCommunicationCopy = await Communication.copy(props.communication.id);
                props.handleCopyCommunication(newCommunicationCopy);
              }

              } // post callback to redux so modal alert calls it on user approval
          }),
        );
      }

  }

  return (

    <Tooltip title={props.type != 'pathway' ? "Copy" : "Convert to Copy"}>
    <IconButton
      data-testid="editIntervalSetButton"
      //disabled={!editMode}
      onClick={handleClick}
    >
      <CopyAllIcon />
    </IconButton>
  </Tooltip>
  )
}

                     


export default InteractionCopyButton